import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import { UsersService } from 'src/app/services/users.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-diagrams-logs',
  templateUrl: './diagrams-logs.component.html',
  styleUrls: ['./diagrams-logs.component.scss']
})
export class DiagramsLogsComponent implements OnInit {

  diagrama: any;
  mainLogoRoute = "../../assets/img/clients/";
  regLogs : any = [];
  message : string = "";
  usersList : any = [];
  filteredUsers: any[] = [];
  previousMessage: string = "";
  mentionedUserIds: number[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private projectService : ProjectsService,
    private main : MainService,
    private userService: UsersService,
  ) {
    this.diagrama = this.data.diagrama;
    this.loadUsers();
    this.loadData();
   }

  ngOnInit(): void {
  }

  loadUsers(){
        this.userService.getUserList().subscribe(
          (result : any) => {
         
            this.usersList = result;
            console.log("users", this.usersList);

          },
          (err : any) => {
            console.log(err);
            
          }
        );
  }

  loadData(first:boolean = true){
    if(first)this.main.ShowLoading();
    this.projectService.getDiagramChangelog(this.diagrama.id).subscribe(
      (result:any) => {
       this.main.HideLoading();
       this.regLogs = result.data;
      },
      (err:any) => {
        this.main.HideLoading();
        if(err.error.message != "No changelog were found in the request")
        {
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener registros',
            text: 'Ocurrió un error al obtener los registros.'
          });
        }
      }
    );
  }

  saveNewMessage(){
    if(this.message!= ""){
      this.main.ShowLoading();
      this.updateMentionedIds();
      this.projectService.newDiagramMessage({"id_diagrama": this.diagrama.id, "message": this.message, "menciones": this.mentionedUserIds}).subscribe(
        (result:any) => {
          this.main.HideLoading();
          if(result.message == "Success") {
            this.message = "";
            this.loadData(false);
          }
        },
        (err:any) => {
          this.main.HideLoading();
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error al guardar',
            text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
          });
        }
      );
    }
  }

  getUserCompanyOrRol(log : any){
    if(log.id_rol == 3 && log.company_name != null){
      return log.company_name;
    }else{
      return log.rol;
    }
  }

  getLogoCompany(logImage : string):string{
    return "url(" + this.mainLogoRoute + logImage + ")"
  }

  onMessageChange(event: KeyboardEvent): void {
    this.previousMessage = this.message;
    const input = event.target as HTMLInputElement;
    const cursorPos = input.selectionStart;
    if (cursorPos === null) return;

    const textToCursor = this.message.substring(0, cursorPos);
    const atMatch = textToCursor.match(/@(\w*)$/);

    if (atMatch) {
      const searchTerm = atMatch[1].toLowerCase();
      this.filteredUsers = this.usersList.filter((user:any) =>
        user.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filteredUsers = [];
    }

    this.updateMentionedIds();
  }

  onUserSelected(userName: string): void {
    const cursorPos = (document.activeElement as HTMLInputElement).selectionStart;
    if (cursorPos === null) return;

    const textToCursor = this.previousMessage.substring(0, cursorPos);
    const atMatch = textToCursor.match(/@(\w*)$/);

    const user = this.usersList.find((u: any) => u.name === userName);
    if (!user) return;

    if (atMatch) {
      const startIndex = atMatch.index!;
      const mention = `@[${userName}] `;
      this.message = this.previousMessage.substring(0, startIndex) + mention + this.previousMessage.substring(startIndex + atMatch[0].length);
      this.filteredUsers = [];
      this.updateMentionedIds();
    }
  }

  updateMentionedIds(): void {
    const mentions = this.message.match(/@\[([^\]]+)\]/g) || [];
    const currentMentions = mentions.map(m => m.substring(2, m.length - 1));

    this.mentionedUserIds = this.usersList
      .filter((user:any) => currentMentions.includes(user.name))
      .map((user:any) => user.id);

    console.log('Mentioned IDs:', this.mentionedUserIds);
  }

}
